
import { Component, Inject, Vue } from "vue-property-decorator";
import Footer from "./Footer.vue";
import Navbar from "./Navbar.vue";
import { Container } from "inversify";
import { SidebarStore } from "../../../../common/src/stores/SidebarStore";
import SubmitFeedbackModal from "../../../../common/src/feedback/SubmitFeedbackModal.vue";
import { FeedbackModalStore } from "../../../../common/src/feedback/FeedbackModalStore";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import {
    hasEnterpriseSubscription,
    hasAccessToDashboard,
    hasActiveQuiltySubscription,
} from "../../../../common/src/utility/entity/user";
import SubscriptionQuoteModal from "../../../../common/src/subscription-quote/SubscriptionQuoteModal.vue";
import IndividualSubscriptionRedirectModal from "../../../../common/src/subscription-quote/IndividualSubscriptionRedirectModal.vue";
import { SubscriptionQuoteModalStore } from "../../../../common/src/subscription-quote/SubscriptionQuoteModalStore";
import { IndividualSubscriptionRedirectModalStore } from "../../../../common/src/subscription-quote/IndividualSubscriptionRedirectModalStore";
import FirstTimeDashboardVisitSideBar from "../user-dashboard/FirstTimeDashboardVisitSideBar.vue";
import DesktopNavigation from "./DesktopNavigation.vue";
import MobileNavigation from "./MobileNavigation.vue";

@Component({
    components: {
        SubscriptionQuoteModal,
        SubmitFeedbackModal,
        IndividualSubscriptionRedirectModal,
        DesktopNavigation,
        MobileNavigation,
        Navbar,
        Footer,
        FirstTimeDashboardVisitSideBar,
    },
})
export default class Layout extends Vue {
    @Inject("container") container!: Container;
    readonly sidebarStore: SidebarStore = this.container.get(SidebarStore);
    readonly feedbackModalStore: FeedbackModalStore = this.container.get(FeedbackModalStore);
    readonly subscriptionQuoteModalStore: SubscriptionQuoteModalStore = this.container.get(
        SubscriptionQuoteModalStore,
    );
    readonly authStore: AuthStore = this.container.get(AuthStore);
    readonly individualSubscriptionRedirectModalStore: IndividualSubscriptionRedirectModalStore =
        this.container.get(IndividualSubscriptionRedirectModalStore);

    get wrapperClass() {
        return {
            "sidebar-enable": this.sidebarStore.isVisible,
            "not-a-member": !hasAccessToDashboard(this.authStore.user),
            "not-enterprise": !hasEnterpriseSubscription(this.authStore.user),
            "not-quilty-member": !hasActiveQuiltySubscription(this.authStore.user),
        };
    }
}
